import { motion } from 'framer-motion'
import { Swiper, SwiperSlide } from "swiper/react";


// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import './style.js'
import "swiper/css/autoplay";


import  { EffectCoverflow, Navigation, Autoplay } from "swiper";
import { StyledIndustrialSection } from "./style.js";
import { useEffect, useRef, useState } from "react";

import blockchain from '../../assets/home-industry-section/blockchain.jpeg'
import ecommerce from '../../assets/home-industry-section/ecommerce.jpg'
import eduction from '../../assets/home-industry-section/eduction.jpeg'
import fintech from '../../assets/home-industry-section/fintech.jpeg'
import food from '../../assets/home-industry-section/food.jpeg'
import healthcare from '../../assets/home-industry-section/healthcare.jpg'
import ondemand from '../../assets/home-industry-section/ondemand.jpeg'
import travel from '../../assets/home-industry-section/travel.jpeg'
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";


const data = [

    {
        title: 'E-Commerce',
        link: 'E-commerce',
        img: ecommerce
    },
    {
        title: 'Fintech',
        link: 'fintech',
        img: fintech
    },
    {
        title: 'Healthcare',
        link: 'healthcare',
        img: healthcare
    },
    {
        title: 'Education',
        link: 'education',
        img: eduction
    },
    {
        title: 'Food & Groceries',
        link: 'food-&-delivery',
        img: food
    },
    {
        title: 'Travel & Tourism',
        link: 'travel-&-tourism',
        img: travel
    },
    {
        title: 'On-Demand Services',
        link: 'on-demand-services',
        img: ondemand
    },
    {
        title: 'Blockchain',
        link: 'blockchain-development',
        img: blockchain
    },
]


const IndustriesSection = () => {

    const [currentSlide, setCurrentSlide] = useState(2);
    const smallerthen640 = useMediaQuery('(max-width:640px)')

    const swiperRef = useRef(null)
    const navigte = useNavigate()

 
    useEffect(() => {
  
        swiperRef.current.swiper.slideToLoop(currentSlide);

    }, [currentSlide]);


    return (
        <div
        >
            <div className="max-w-screen-2xl mx-auto px-5 py-6 md:py-10"

            >
                <motion.div
                    whileInView={{ opacity: [0, 1] }}
                    transition={{ duration: 1.0 }}>
                    <p className="text-center text-2xl font-bold dark:text-white">
                        Industries{" "}
                        <span className="text-red-500">
                            in Focus
                        </span>
                    </p>
                    <StyledIndustrialSection>
                        <div className="w-[100%] lg:w-[80%] mx-auto mt-5 pb-3">

                            <div className="flex gap-3 justify-center flex-wrap xl:px-5">
                                {data.map((item, i) => (
                                    <h5 key={i} onClick={() => setCurrentSlide(i)} className={`text-[14px] sm:text-sm font-semibold  cursor-pointer hover:text-red-500 duration-700 ${i === currentSlide ? 'text-red-500' : 'text-gray-500'}`}>
                                        {item.title}
                                    </h5>
                                ))}
                            </div>

                            <Swiper
                                onSlideChange={(swiper) => setCurrentSlide(swiper.realIndex)}
                                effect={"coverflow"}
                                grabCursor={true}
                                loop={true}
                                autoplay={{
                                    pauseOnMouseEnter: true,
                                }}
                                initialSlide={currentSlide}
                                centeredSlides={true}
                                slidesPerView={smallerthen640 ? 1 : 3}
                                ref={swiperRef}
                                speed={800}
                                navigation={true}
                                coverflowEffect={{
                                    rotate: 50,
                                    stretch: 0,
                                    depth: 100,
                                    modifier: 1,
                                    slideShadows: true,
                                }}
                                modules={[EffectCoverflow, Navigation, Autoplay]}
                                className="w-full h-[330px] md:h-[350px]"
                                style={{
                                    "--swiper-navigation-size": "25px",
                                    padding: '0 30px',
                                    marginTop: '35px'
                                }}
                            >
                                {data.map((item, i) => (

                                    <SwiperSlide key={i} className={`relative ${currentSlide !== i && 'opacity-50 mt-4'}`} >
                                        <div className={`relative  ${currentSlide === i && ' hover:shadow-2xl hover:scale-95 duration-700'}`} onClick={() => setCurrentSlide(i)}>
                                            <img src={item.img} alt='img' className="h-[330px] md:h-[350px]" />
                                            <div className="absolute top-0 left-0 right-0">
                                                <h1 className="text-center text-white font-bold text-xl md:text-2xl pt-4 px-1">
                                                    {item.title}
                                                </h1>
                                            </div>

                                            {currentSlide === i && (
                                                <div className="absolute bottom-6 left-0 right-0">
                                                    <div className="flex justify-center">

                                                        <button
                                                            onClick={() => navigte(`/${item.link}`)}
                                                            className="rounded-lg px-5 py-1.5 overflow-hidden relative group cursor-pointer border-2 font-medium text-xs border-yellow-500 text-yellow-500 ">
                                                            <span className="absolute w-64 h-0 transition-all duration-700 origin-center rotate-45 -translate-x-20 bg-yellow-500 top-1/2 group-hover:h-64 group-hover:-translate-y-32 ease"></span>
                                                            <span className="relative text-yellow-500 transition duration-700 group-hover:text-white ease">Load more</span>
                                                        </button>

                                                    </div>
                                                </div>)}
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                            <div className="sm:w-[650px] mx-auto mt-8">
                                <p className="text-[14px] md:text-[20px] sm:text-center text-gray-500">
                                    CodeZone offers consulting services, development for custom software such as digital payment solutions, banking apps, accounting software consulting, etc. We help fintech businesses with all aspects of their operations including strategy development, product design & management, and technical support.
                                </p>
                            </div>
                        </div>
                    </StyledIndustrialSection>
                </motion.div>
            </div>
        </div>
    )
}

export default IndustriesSection